// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "Carousel__textCenter__iAiUM";
export const carousel = "Carousel__carousel__RH2X2";
export const carouselInner = "Carousel__carouselInner__wGYA-";
export const carouselSlideWrpaper = "Carousel__carouselSlideWrpaper__M0IuU";
export const slideWrapper = "Carousel__slideWrapper__bv0AL";
export const invisible = "Carousel__invisible__ipYZj";
export const dots = "Carousel__dots__EVRzm";
export const dot = "Carousel__dot__r+c06";
export const activeDot = "Carousel__activeDot__981uY";